// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"dba59755","648":"a54bcf57"}[chunkId] + ".chunk.js";
};